import React, { Component } from "react";
import Avatar from "../chatList/Avatar";

export default class ChatItem extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        style={{ animationDelay: `0.8s` }}
        className={`chat__item ${this.props.user ? this.props.user : ""}`}
      >
        <div className="chat__item__block">
        <div className="chat__item__content">
          <div className="chat__msg">{this.props.msg}</div>
        </div>
          <div className="chat__meta">
            <span>{this.props.date}</span>
            </div>
         </div>
        <Avatar isOnline="active" image={this.props.image} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/chatContent/ChatItem.js